import React from 'react';
import PropTypes from  'prop-types';
import HorseRacingFastRacecardRide from 'modules/HorseRacing/components/HorseRacingFastRacecardRide';
import CaretIcon from '../../Common/components/svg/CaretIcon';

HorseRacingFastRacecardExtraPlaces.propTypes = {
  rides: PropTypes.array,
  places: PropTypes.number,
  favToken: PropTypes.string
}

export default function HorseRacingFastRacecardExtraPlaces({rides, places, favToken}) {

  if (!rides || rides.length == 0) {
    return null;
  }

  return (
    <div className="fast-results-extra-places">
      <div className="fast-results-extra-places-header fast-results-extra-places-marginals">
      <span className="skycon">{String.fromCharCode(0xF30F)}</span>Sky Bet paid {places} places on this race
        <span className="logo"><img src="/img/masthead/skybet-dec2017.png"></img></span>
      </div>
      <div className="fast-results-extra-places-content">
        {rides.map(ride => <HorseRacingFastRacecardRide key={ride.horse_reference.id} ride={ride} favToken={favToken} />)}
      </div>
      <div className="fast-results-extra-places-footer fast-results-extra-places-marginals">
        <a target="_blank" href="https://m.skybet.com/horse-racing/meetings?affid=720&dcmp=sl_fr_extra_places">
          <span>Tap here for the next Sky Bet Extra place race </span>
          <CaretIcon type={"line"} direction="right" />
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingFastRacecardExtraPlaces.js